import React from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export default function UserRolesTable({
  users,
  roleList,
  userActionPending,
  passwordResetPending,
  onUserRoleChange,
  onResetPassword,
}) {
  return (
    <Paper variant="outlined" sx={{p: 2}}>
      <Typography variant="h6" sx={{mb: 2}}>
        Rollen je Benutzer
      </Typography>
      {users.length === 0 ? (
        <Typography color="text.secondary">Keine Benutzer gefunden.</Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Benutzer</TableCell>
              <TableCell>E-Mail</TableCell>
              <TableCell>Rollen</TableCell>
              <TableCell>Aktionen</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id} hover>
                <TableCell>{`${user.firstname ?? ''} ${user.lastname ?? ''}`.trim() || user.username}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id={`user-roles-label-${user.id}`}>Rollen</InputLabel>
                    <Select
                      labelId={`user-roles-label-${user.id}`}
                      label="Rollen"
                      multiple
                      value={user.roleIds ?? []}
                      onChange={(event) => onUserRoleChange(user, event.target.value)}
                      renderValue={(selected) =>
                        roleList
                          .filter((role) => selected.includes(role.id))
                          .map((role) => role.name)
                          .join(', ') || '–'
                      }
                      disabled={userActionPending === user.id}
                    >
                      {roleList.map((role) => (
                        <MenuItem key={role.id} value={role.id}>
                          <Checkbox checked={user.roleIds?.includes(role.id)} />
                          <ListItemText primary={role.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    size="small"
                    color="warning"
                    onClick={() => onResetPassword(user)}
                    disabled={userActionPending === user.id || passwordResetPending === user.id}
                  >
                    {passwordResetPending === user.id ? 'Zuruecksetzen...' : 'Passwort zuruecksetzen'}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
